function parseKey(key) {
    // 支持以类 json Path 方式 获取变量内部的值
    let keyMatch = key.match(/^([^.\[]+)([.\[])(.+)$/);
    let jsonPathExpression;
    if (keyMatch) {
        key = keyMatch[1];
        jsonPathExpression = `$${keyMatch[2]}${keyMatch[3]}`;
    }
    return {
        key,
        jsonPathExpression,
    };
}

function getJsonValue(value, jsonPathExpression) {
    // 支持以类 json Path 方式获取变量内部的值
    if (jsonPathExpression && value) {
        if (typeof value === 'string') {
            try {
                value = JSON.parse(value);
            } catch (e) {}
        }
        if (typeof value === 'object') {
            const JSONPath = require('jsonpath-plus').JSONPath;
            return JSONPath({
                json: value,
                path: jsonPathExpression,
                wrap: false
            });
        } else {
            return;
        }
    } else {
        return value;
    }
}

module.exports = {
  parseKey,
  getJsonValue
};
